import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
const defaultAnimation = {
    loop: true,
    from: { rotateZ: 0 },
    to: { rotateZ: 360 },
    config: { duration: 750 },
};
const Spinner = ({ color = 'primary', animationConfig = {}, customClassName = '', inlineStyles = {} }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const interpolation = useSpring(Object.assign(Object.assign({}, defaultAnimation), animationConfig));
    const containerStyle = clsx({
        [classes.container]: true,
        [classes[color]]: Boolean(color),
        [customClassName]: Boolean(customClassName)
    });
    return React.createElement(animated.div, { className: containerStyle, style: Object.assign(Object.assign({}, inlineStyles), interpolation) });
};
export { Spinner };
//# sourceMappingURL=Spinner.js.map